import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { GetChatProfiles } from './request';
import { getChatProfile } from './request';

export const useGetChatProfileQuery = (
  params: GetChatProfiles,
  settings?: QuerySettings<typeof getChatProfile>
) =>
  useQuery({
    queryKey: ['getChatProfile', params.profileId, params.profileType],
    queryFn: () =>
      getChatProfile({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
